import { ReactNode } from 'react';

interface ActionNeededItemRowProps {
  testIdPrefix: string;
  itemId: string;
  onOpen: () => void;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

export const ActionNeededItemRow = ({
  testIdPrefix,
  itemId,
  onOpen,
  actions,
  className = '',
  children
}: ActionNeededItemRowProps) => {
  const itemAttributes = {
    [`data-${testIdPrefix}-item`]: true,
    'data-testid': `${testIdPrefix}-item-${itemId}`,
    'data-cy': `${testIdPrefix}-item-${itemId}`
  };

  const openTarget = (attributes = {}) => (
    <div
      role="button"
      tabIndex={0}
      data-dd-action-name="Action Needed entry"
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onOpen();
        }
      }}
      className={[
        'cursor-pointer rounded-md px-2 py-1 -mx-2 hover:bg-[#F5F5F5]',
        actions ? 'min-w-0 flex-1' : className
      ]
        .filter(Boolean)
        .join(' ')}
      {...attributes}>
      {children}
    </div>
  );

  if (!actions) return openTarget(itemAttributes);

  // A button's contents are presentational to assistive tech, so the actions sit beside it rather than inside it.
  return (
    <div
      className={`flex items-start gap-4 ${className}`}
      {...itemAttributes}>
      {openTarget()}
      <div className="shrink-0">{actions}</div>
    </div>
  );
};
